/* eslint-disable linebreak-style */
/* eslint-disable import/no-cycle */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable spaced-comment */

import classNames from "classnames/bind";
import { ReactNode } from "react";
import styles from "./StatusLabel.module.scss";

const cx = classNames.bind(styles);

const STATUSES = {
  Activé: styles.enabled,
  Payée: styles.enabled,
  Payé: styles.enabled,
  Ouvert: styles.enabled,
  Disponible: styles.enabled,
  Indisponible: styles.unavailable,
  Plombé: styles.available,
  "En cours": styles.available,
  "Délai échu": styles.unavailable,
  "Non disponible": styles.unavailable,
  Rappelé: styles.unavailable,
  "Offre TVT Basic": styles.enabled,
  "Offre TV+": styles.enabled,
  "Offre TVT Pro": styles.enabled,
};

type StatusLabelProps = {
  status?:
    | "Activé"
    | "Payée"
    | "Payé"
    | "Ouvert"
    | "Disponible"
    | "Indisponible"
    | "Plombé"
    | "En cours"
    | "Délai échu"
    | "Non disponible"
    | "Rappelé"
    | "Offre TVT Basic"
    | "Offre TV+"
    | "Offre TVT Pro";
  label?: string;
  border?: boolean;
  children?: ReactNode;
  className?: string;
};

const StatusLabel = ({
  status = "Payée",
  label = "",
  border = true,
  className = "",
  children,
}: StatusLabelProps) => (
  <p
    className={cx(STATUSES[status], { [styles.noBorder]: !border }, className)}
  >
    {children || label || status}
  </p>
);

export default StatusLabel;
